import React from 'react';
import { Switch, Route } from 'react-router-dom';

// pages
import Add from './Add';
import List from './List';
import Info from './Info';

class Service extends React.PureComponent {
    render() {
        return (
            <Switch>
                <Route exact path='/popup/add' component={Add} />
                <Route exact path='/popup/list' component={List} />
                <Route exact path='/popup/info/:id' component={Info} />
            </Switch>
        );
    }
}
export default Service;
